import React from 'react'
import Slider from 'react-slick'
import './style.css'

import useWindowDimension from '../../../hooks/useWindowDimension'

import ComponentTitle from '../../../components/ComponentTitle/ComponentTitle'
import pashaLogo from '../../../resources/images/pasha-icon.svg'
import swissCapitalLogo from '../../../resources/images/swiss-capital-icon.svg'
import libertyLogo from '../../../resources/images/liberty-icon.svg'
import halykBank from '../../../resources/images/halyk-bank-logo.svg'
import europeBetLogo from '../../../resources/images/europebet.svg'
import betLiveLogo from '../../../resources/images/betlive.svg'
import leaderBetLogo from '../../../resources/images/leaderBet.svg'

import { StyledContainer, StyledMainContainer, StyledTitleContainer } from './KvaliCustomersStyle'

const KvaliCustomers = ({ hasHeader }) => {
	const { isMobile } = useWindowDimension()

	const settings = {
		className: 'variable-width',
		infinite: true,
		variableWidth: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 1000
	}
	const settingsMobile = {
		// className: 'variable-width',
		autoplay: true,
		autoplaySpeed: 1000,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1
	}

	return (
		<StyledContainer>
			{hasHeader && (
				<StyledTitleContainer>
					<ComponentTitle value='ourCustomers' />
				</StyledTitleContainer>
			)}
			<StyledMainContainer>
				{!isMobile && (
					<Slider {...settings}>
						<img src={europeBetLogo} alt='' />
						<img src={betLiveLogo} alt='' />
						<img src={leaderBetLogo} alt='' />
						<img src={halykBank} alt='' />
						<img src={pashaLogo} alt='' />
						<img src={libertyLogo} alt='' />
						<img src={swissCapitalLogo} alt='' />
					</Slider>
				)}
				{isMobile && (
					<Slider {...settingsMobile}>
						<img src={europeBetLogo} alt='' />
						<img src={betLiveLogo} alt='' />
						<img src={leaderBetLogo} alt='' />
						<img src={halykBank} alt='' />
						<img src={pashaLogo} alt='' />
						<img src={libertyLogo} alt='' />
						<img src={swissCapitalLogo} alt='' />
					</Slider>
				)}
			</StyledMainContainer>
		</StyledContainer>
	)
}

export default KvaliCustomers
